import { render, staticRenderFns } from "./LocalCategoryForm.vue?vue&type=template&id=7dea382d&"
import script from "./LocalCategoryForm.vue?vue&type=script&lang=js&"
export * from "./LocalCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports